module.exports = __webpack_public_path__ + "img/syllabus-title.c8893f08.png";